import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';

import { salesTaxTableFormatters } from './salesTaxTableFormatters';

const createTableColumns = () => [
  {
    Header: (
      <div>
        {salesTaxTableFormatters.reportDate.label}
        <FontAwesomeIcon className="ml-1 not-small" icon={faSort} />
      </div>
    ),
    headerClassName: 'd-flex align-items-center',
    id: 'report-date',
    className: 'wrap-table-cell',
    minWidth: 25,
    sortable: true,
    accessor: d => d,
    Cell: ({ value }) => (
      <span>
        {salesTaxTableFormatters.reportDate.formatter(value)}
      </span>
    )
  },
  {
    Header: (
      <div>
        {salesTaxTableFormatters.state.label} <FontAwesomeIcon className="ml-1 not-small" icon={faSort} />
      </div>
    ),
    headerClassName: 'd-flex align-items-center',
    id: 'state-name',
    className: 'wrap-table-cell',
    minWidth: 25,
    sortable: true,
    accessor: d => d,
    Cell: ({ value }) => (
      <span>
        {salesTaxTableFormatters.state.formatter(value)}
      </span>
    )
  },
  {
    Header: (
      <div>
        {salesTaxTableFormatters.grossSales.label} <FontAwesomeIcon className="ml-1 not-small" icon={faSort} />
      </div>
    ),
    headerClassName: 'd-flex align-items-center',
    id: 'gross-sales',
    className: 'wrap-table-cell',
    minWidth: 25,
    sortable: true,
    accessor: d => d,
    Cell: ({ value }) => (
      <div className="text-end">
        ${salesTaxTableFormatters.grossSales.formatter(value)}
      </div>
    )
  },
  {
    Header: (
      <div>
        {salesTaxTableFormatters.salesTaxCollected.label} <FontAwesomeIcon className="ml-1 not-small" icon={faSort} />
      </div>
    ),
    headerClassName: 'd-flex align-items-center',
    id: 'sales-tax-collected',
    className: 'wrap-table-cell',
    minWidth: 25,
    sortable: true,
    accessor: d => d,
    Cell: ({ value }) => (
      <div className="text-end">
        ${salesTaxTableFormatters.salesTaxCollected.formatter(value)}
      </div>
    )
  },
];

const SalesTaxReportsTable = ({ data }) => (
  <ReactTable
    className="-highlight mt-4 w-100 mb-5"
    minRows={1}
    data={data}
    defaultPageSize={50}
    noDataText="No sales tax report(s) have been generated"
    pageSizeOptions={[50, 100, 200]}
    columns={createTableColumns()}
    rowsText="per page"
    showPageJump={false}
  />
);

SalesTaxReportsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default SalesTaxReportsTable;
